<template>
    <div>
        <a @click.prevent="open" class="btn-outlined btn-enter">
            <img src="/img/front/icons/phone.svg" alt="" class="icon">
            <span class="text">
                {{ trans('auth.enter_by_phone') }}
            </span>
        </a>
        <modal-phone v-if="openModal" @close="close" @set="set" />
    </div>
</template>

<script>
import phoneModal from "./PhoneModal";

export default {
    props: {
        type: {
            required: false,
            default: null
        }
    },
    data() {
        return {
            openModal: false
        }
    },
    components: {
        "modal-phone": phoneModal
    },
    methods: {
        open() {
            this.openModal = true;
            document.getElementsByTagName('html')[0].classList.add('popup-show');
        },
        close() {
            this.openModal = false;
            document.getElementsByTagName('html')[0].classList.remove('popup-show');
        },
        set(data) { 
            this.$emit("set", data);
        }
    }
}
</script>